import { Component, OnInit, Input, ViewChild, ViewContainerRef, ComponentFactoryResolver, ElementRef, Output, EventEmitter, Inject, ChangeDetectorRef, HostListener } from '@angular/core';
import { TyphographyComponent } from '../bookShared/bookeditoption/bookEditOptionPopups/text/typhography/typhography.component';
import { PageEnrichmentsComponent } from '../bookShared/popups/pageEnrichments/pageEnrichments.component';
import { PalleteComponent } from '../bookShared/popups/pallete/pallete.component';
import { ParentviewComponent } from '../bookShared/enrichmentTabs/enrichmentTabPopups/parentview/parentview.component';
import { SmartviewComponent } from '../bookShared/popups/smartview/smartview.component';
import { BookmoreoptionsComponent } from '../bookShared/popups/bookmoreoptions/bookmoreoptions.component';
import { PagesIndexComponent } from '../bookShared/enrichmentTabs/enrichmentTabPopups/pagesIndex/pagesIndex.component';
import { PageCreationComponent } from '../bookShared/popups/pageCreation/pageCreation.component';
import { EBEpouchdbService } from './EBEpouchdb.service';
import { Constants } from '../shared/models/constants';
import { SafePipe } from './safePipe';
import { Page } from '../shared/models/page';
import { BookData } from '../shared/models/bookData';
import { Book } from '../shared/models/book';
import { MiniBookComponent } from '../bookShared/popups/mini-book/mini-book.component';
import { EnrichmentPage } from '../shared/models/enrichmentPage';
import { IS_ElectronService } from '../shared/IS_Electron.service';
import { PageContent } from '../shared/models/pageContent';
import { LiquidModel } from '../shared/models/liquidModel';
import { EditOptionService } from '../bookShared/bookeditoption/editOptions.service';
import { ISubscription } from "rxjs/Subscription";
import { EnrichmentTabsComponent } from "../bookShared/enrichmentTabs/enrichmentTabs.component"
import { NoteComponent } from '../bookShared/popups/Note/Note.component'
import * as _ from "lodash";
import { EnrichmentTabsService } from '../bookShared/enrichmentTabs/enrichmentTabs.service';
import { ShelfPouchDb } from '../shelf/shelf.pouchdb.service';
import { Component_interactionService } from '../component_interaction.service';
import { PageTemplate } from '../shared/models/pageTemplate';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { EditorService } from "../bookShared/bookeditoption/editor.service";
import { CreateTemplateDialogueComponent } from '../bookShared/popups/create-template-dialogue/create-template-dialogue.component';
import { DeletePopupComponent } from '../shared/deletePopup/deletePopup.component'
import { BookInfoComponent } from '../bookShared/popups/bookInfo/bookInfo.component';
import { createEleComponent } from '../shelf/mycontent/mycontent.component';
import { donwloadEleService } from '../bookShared/downloadELE.service';
import { MatSnackBar } from '@angular/material';
import { LoginObservableService } from '../shared/loginObservable.service';
import { ExportviewComponent } from '../bookShared/popups/export/export.component';
@Component({
  selector: 'app-EBE',
  templateUrl: './EBE.component.html',
  styleUrls: ['./EBE.component.css']
})
export class EBEComponent implements OnInit {

  @ViewChild(EnrichmentTabsComponent)
  private enrichmentTabsScope: EnrichmentTabsComponent;

  @Input() data: any
  public bookObj: Book;
  public totalPdfPages;

  public youtubeSrc = "";
  private subscription: ISubscription;
  public bookDataObj: any;
  public pageObj: Page;
  public showFullViewDiv: boolean = false;

  public fullViewPageNumber: any;


  public pdfPath: String = '';
  public coverPagePath: String = '';
  public rightSvgPath: String = '';
  public isShowDrawingPicker = false;
  zoomPlusMinus = 1;
  popupParams: any = {
    height: 300,
    width: 300,
    direction: "left",
    arrowPos: 50,
    showPopup: false,
    loadDirective: "",
    curComp: this,
    isResize: false
  };

  globalPopupPara = <any>{};
  addClickPopupPara = <any>{};
  addTabtype;
  public enrichmentTabs;
  public currentLoadingPage: EnrichmentPage;
  selectedOption;
  gotoBack = false;
  public isCreatedEBE: boolean = true;
  public bookTemplateObj: any;
  public frontCoverPageObj: any;
  public backCoverPageObj: any;
  public canvasPoint = [];
  public pagesArray: any = [];
  public isCoverPage: boolean = true;
  public rootTabActive: boolean = true;
  public currentPageNumber: any = 1;
  public bookTemplates: any;
  public showpagesAddingCon: boolean = false;
  pageContent: any;
  PDF_DOC;
  pageEnrichmentsLength;
  pageNotesLength;
  @ViewChild("panel", { read: ElementRef })
  public panel: ElementRef;
  public reloadEditor = true;
  sortablePages;

  public frontObj;
  public backObj;

  selectedCEPopupIndex;
  slider
  sliderWidth
  sliderOffsetX
  sliderOffsetY
  sliderCpos = 1;
  public fullViewSliderCpos: number = 1;
  pageIsBookmarked;
  pageIsDrawing;
  appendPageEnrichments;
  selectedPopupIndex;
  selectedBottomPopupIndex;
  selectedCreatedEBEListIndex;
  selectedAddPagePopupIndex;
  public pageContentModel;
  public loadEnrichments = false;
  updateFromPageenrichState: any;
  showEnrichmentsFullViewDiv = false;
  public showFullViewHeader: boolean = false;

  public internetSearchObj: any = {
    showPopup: false
  }

  public youtubeSearchObj: any = {
    showPopup: false
  }

  public googleServicesObj: any = {
    showPopup: false,
    googleServiceType: ""
  }

  public pageFromBookObj: any = {
    showPopup: false,
    bookObj: this.bookObj
  }
  public templateAsEnrichmentObj: any = {
    showPopup: false
  }

  public selectedExportIconIndex: any;
  public bookSubscription;
  constructor(public snackBar: MatSnackBar, public dowloadservice: donwloadEleService, private viewContainerRef: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver, public dialog: MatDialog,
    private pouchService: EBEpouchdbService, private enrichemntspService: EnrichmentTabsService, private ElectronService: IS_ElectronService, private cdr: ChangeDetectorRef, public shelfPouchService: ShelfPouchDb,
    private Component_interactionService: Component_interactionService, private editorService: EditorService, private elem: ElementRef, private LoginObservableService: LoginObservableService) {
    if (!this.ElectronService.IS_ELECTRON)
      this.bookTemplates = Constants.getTemplates();
    else
      this.bookTemplates = Constants.getElectronTemplates();
    // this.subscription =this.pouchService.pageContentData$.subscribe(evt => {

    //   this.setPageConent(evt);

    // });
    this.sortablePages = {

      onUpdate: (event: any) => {

        this.bookDataObj = this.pouchService.reOrderPages(this.bookDataObj, event.target.children, event.newIndex);
        this.setbookData();
        if (this.enrichmentTabsScope) {
          var pageIndex = this.bookDataObj["" + this.bookDataObj.lastOpenedPage].pageNumber;
          this.enrichmentTabsScope.updateTabs(this.bookDataObj.lastOpenedPage, pageIndex, this.bookDataObj["" + this.bookDataObj.lastOpenedPage]);
        }
      }

    };

  }

  setPageConent(data) {
    this.reloadEditorM();
    this.pageContentModel = data;
    this.pageContent = data.pageContent;
  }
  // getScreenShot(){  
  //   var self = this;     
  //   document['html2canvas'](document.querySelector('.appEditorContainer'))
  //   .then(function(canvas) {
  //       console.log("html2canvas");
  //       let pngUrl = canvas.toDataURL();
  //       self.frontObj.eleUrl = pngUrl;      
  //   });

  // }

  setbookData() {
    //this.bookDataObj = bookData;
    this.updatePages();
    // this.pageObj = this.bookDataObj["" + this.bookDataObj.pages[0]];
    this.pageObj = this.bookDataObj["" + this.bookDataObj.lastOpenedPage];
    this.pouchService.getPageContent(this.bookDataObj["" + this.bookDataObj.lastOpenedPage].contentDocId, this);
    var LOPIndex = this.bookDataObj.pages.indexOf(this.bookDataObj.lastOpenedPage.toString());
    if (LOPIndex != 0 && LOPIndex != this.bookDataObj.pages.length - 1) {
      this.loadEnrichmentsTab();
    }
  }
  ngOnDestroy() {
    if (this.bookSubscription) this.bookSubscription.unsubscribe();
    
   
  }

  toolbarList = [
    { icon: "icon-page-structure", number: "4" },
    { icon: "icon-Notes-V", number: "2" },
    // { icon: "icon-BookMark-V", number: "4" },
    // { icon: "icon-Drawing", number: "4" }
  ];
  toolbarList2 = [
    "icon-lesson-structure-2",
    "icon-Imports",
    // "icon-Book-Export",
    // "icon-Presentation-V"
  ];

  createdEBELists = [
    { name: "Save", icon: "icon-Save-as-Template" },
    { name: "Delete", icon: "icon-Delete" },
  ];

  createdEBELists2 = [
    { name: "BookSmartView", icon: "icon-lesson-structure-2" },
    { name: "Add", icon: "icon-Plus-Line" },
    //  { name: "BookSmartView", icon: "icon-lesson-structure-2" },

  ];

  createdEBELists3 = [
    { name: "Export", icon: "icon-Book-Export" },
    { name: "Presentation", icon: "icon-Presentation-V" }
  ]


  ngOnInit() {
    document['ebeDoc'] = this;
    var self = this;
    if (this.data.bookObj) {
      this.bookObj = this.data.bookObj;
      this.bookDataObj = this.data.bookDataObj;

      this.initialize();

      if (this.bookDataObj && this.bookDataObj.lastOpenedPage) {
        this.currentPageNumber = this.bookDataObj.lastOpenedPage;
      }

      if (this.bookDataObj && this.currentPageNumber && this.bookDataObj[this.currentPageNumber]) {

        this.sliderCpos = this.currentPageNumber;
        this.pageIsBookmarked = this.bookDataObj[this.currentPageNumber].bookmarks;
        if (this.bookDataObj[this.currentPageNumber].drawingArr && this.bookDataObj[this.currentPageNumber].drawingArr.length > 0) {
          this.canvasLineJson = this.bookDataObj[this.currentPageNumber].drawingArr;
          if (this.canvasLineJson.length)
            // this.canvasPoint = this.canvasLineJson;
            this.canvasPoint = JSON.parse(JSON.stringify(this.canvasLineJson));
          this.pageIsDrawing = this.bookDataObj[this.currentPageNumber].drawing;
        }
        this.pageEnrichmentsLength = (this.bookDataObj[this.currentPageNumber].enrichment_page).length;
        this.pageNotesLength = (this.bookDataObj[this.currentPageNumber].notes).length;
      }
      if (this.bookObj.bookCategory == 0 && this.data.isBook) {
        this.isCreatedEBE = false;
      }
      this.bookSubscription = this.ElectronService.isShelfBook$.subscribe(message => {
        console.log("beforesubscriptionEBE");
        if (message) {
          console.log("aftersubscriptionEBE");
          self.isCreatedEBE = false;
        //  self.cdr.detectChanges();
        }
      });




    }
    this.updateBookPaths();

  }

  ngAfterViewInit() {
    this.getHeight();
    this.cdr.detectChanges();
  }


  initialize() {
    var self = this;
    if (this.bookObj.bookCategory == 1) {
      this.isCreatedEBE = true;
      //   this.isCoverPage = true;
      setTimeout(() => {
        this.showPagesContainer();
      }, 0);
      if (this.bookObj.isCustomTemplate)
        this.bookTemplateObj = this.shelfPouchService.getCustomTemplate(this.bookObj.templateId);
      else
        this.bookTemplateObj = this.bookTemplates[this.bookObj.templateId + ""];
      this.bookObj.coverPage = this.bookTemplateObj.card;//update coverpage        

      this.setbookData();
      // this.pouchService.getPages(this.bookObj,this.bookTemplateObj,this);
    }
    else {
      if (this.bookDataObj) {
        this.pageObj = this.bookDataObj["" + this.bookDataObj.lastOpenedPage];
      }
    }
  }
  showPagesContainer() {
    this.showpagesAddingCon = true;
    this.elem.nativeElement.querySelectorAll('.ebePagesPopup')[0].classList.add('boxShadowForpagesDiv');

    setTimeout(() => {
      this.togglePagesList();
    }, 1000);
  }
  // @HostListener('document:click', ['$event'])
  // clickout(event) {
  //   if(this.elem.nativeElement.contains(event.target)) {
  //    console.log("clicked inside" +event.target);
  //   } else {
  //     console.log("clicked inside"+event.target);
  //   }
  // }

  // updateElectronSettings() {
  //   // var bookPath = this.ElectronService.APP_PATH + '/' + this.bookObj.bId;
  //   var bookPath = this.ElectronService.USER_PATH + '/' + this.bookObj.bId;
  //   var bookTemplateIdPath = bookPath + '/Templates/' + this.bookObj.templateId;
  //   if (!this.ElectronService.FS.existsSync(bookPath)) { //If books does not exists
  //     this.ElectronService.downloadBook(this.bookObj);
  //   }
  //   else if (this.isCreatedEBE && !this.ElectronService.FS.existsSync(bookTemplateIdPath)) {
  //     this.ElectronService.downloadTemplateIdPath(bookTemplateIdPath, this.bookObj);
  //   }
  //   else {
  //     this.updateElectronBookPaths();
  //   }
  //   this.ElectronService.isBook$.subscribe(message => {
  //     this.updateElectronBookPaths();
  //   });

  // }

  updateElectronBookPaths() {

    // var bookPath = 'assets/Nooor/' + this.bookObj.bId;
    if (localStorage.userData == 'undefined')
      var bookPath = 'assets/Nooor/Default' + '/' + this.bookObj.bId;
    else
      var bookPath = 'assets/Nooor/' + this.ElectronService.USER_ID + '/' + this.bookObj.bId;
    this.rightSvgPath = 'assets/pdfRight/RightRoundTab.svg';
    if (this.bookObj.bookCategory == 1) {
      // this.coverPagePath = bookPath + '/Templates/' + this.bookObj.templateId + '/card.png';
      this.coverPagePath = 'assets/Templates/' + this.bookObj.templateId + '/card.png';
    }
    else {
      this.pdfPath = bookPath + '/Pdf.pdf';
      this.coverPagePath = bookPath + '/cover.png';
    }
  }
  updateBookPaths() {
    this.pdfPath = this.bookObj.url;
    this.coverPagePath = this.bookObj.coverPage;
    this.rightSvgPath = '../assets/pdfRight/RightRoundTab.svg';
    this.cdr.detectChanges();

  }

  updatePages() {
    this.pagesArray.length = 0;
    var obj;
    // var bookPath = 'assets/Nooor/' + this.bookObj.bId;
    //  var bookPath = 'assets/Nooor/' + this.ElectronService.USER_ID + '/' + this.bookObj.bId;
    var bookPath = 'assets';
    for (let i = 0; i < this.bookDataObj.pages.length; i++) {
      if (i == 0) {
        this.frontObj = {
          "id": this.bookDataObj.pages[i],
          "url": this.bookTemplateObj.frontThumb,
          "eleUrl": bookPath + '/Templates/' + this.bookObj.templateId + '/frontThumb.png',
          "type": 'front',
          "name": "Cover Page"
        }
      }
      else if (i == this.bookDataObj.pages.length - 1) {
        this.backObj = {
          "id": this.bookDataObj.pages[i],
          "url": this.bookTemplateObj.backThumb,
          "eleUrl": bookPath + '/Templates/' + this.bookObj.templateId + '/backThumb.png',
          "type": 'back',
          "name": "End Page"
        }
      }
      else {
        obj = {
          "name": this.bookDataObj[this.bookDataObj.pages[i]].title,
          "id": this.bookDataObj.pages[i],
          "url": this.bookTemplateObj.pageThumb,
          "eleUrl": bookPath + '/Templates/' + this.bookObj.templateId + '/pageThumb.png',
          "type": 'page',
          "index": i
        }
        this.pagesArray.push(obj);
      }

    }

  }


  async addPage(pageUrlObj, type) {
    this.bookObj.pageCount = this.bookObj.pageCount + 1;
    // var timestamp = Math.floor(Date.now() / 1000);
    var timestamp = Constants.getGUID();
    //  var bookPath = 'assets/Nooor/' + this.bookObj.bId;
    //  var bookPath = 'assets/Nooor/' + this.ElectronService.USER_ID + '/' + this.bookObj.bId;
    var bookPath = 'assets';
    var obj = {
      "name": "Page" + (this.bookObj.pageCount),
      "id": timestamp,
      "url": this.bookTemplateObj.pageThumb,
      "eleUrl": bookPath + '/Templates/' + this.bookObj.templateId + '/pageThumb.png',
      "type": 'page',
      "index": this.bookObj.pageCount
    }
    // this.pagesArray.splice( this.pagesArray.length-1, 0, obj );
    //this.pagesArray.insert(this.pagesArray.length-1,obj);
    this.pagesArray.push(obj);

    this.currentPageNumber = timestamp;
    // this.pouchService.createPageContent(this, timestamp);
    var liquidModel: LiquidModel = new LiquidModel();
    var pageContent: PageContent = new PageContent();
    var page: Page = new Page();
    pageContent._id = Constants.USER + "." + timestamp + ".pageContent";
    if (!pageUrlObj) {
      if (this.bookTemplateObj.type && this.bookTemplateObj.type == 1) {
        let pageId = this.bookDataObj.pages[1];
        await this.pouchService.getTemplatePageContent(this.bookDataObj[pageId.toString()].contentDocId).then(function (res) {
          if (res) {
            pageContent.pageContent = res['pageContent'];
          }
        });
      }
      else {
        liquidModel.pageBgStyle = { "type": "image", "url": this.bookTemplateObj.page_P, aspectRatio: true };
        pageContent.pageContent = liquidModel;
      }
    }
    else {
      if (type == 'pageFromBook') {
        liquidModel.pageBgStyle = { "type": "image", "url": pageUrlObj.url, aspectRatio: true };
        pageContent.pageContent = liquidModel;
      }
      else if (type == "youtube") {
        page.description.url = "https://www.youtube.com/embed/" + pageUrlObj.videoId;
        page.description.key = pageUrlObj.videoId;
        pageContent.pageContent = liquidModel;
      }
      else if (type == "template") {
        var self = this
        await this.pouchService.getTemplatePageContent(pageUrlObj.contentDocId).then(async function (res) {
          if (res) {
            pageContent.pageContent = res['pageContent'];
          }
        });
      }
      else if (type == "internet") {
        page.description.url = pageUrlObj.url;
        if (pageUrlObj.title.length > 0) {
          page.description.key = pageUrlObj.title;
        }
        pageContent.pageContent = liquidModel;
      }
      else if (type == "googleDocs" || type == "spreadSheet" || type == "presentation") {
        page.description.url = pageUrlObj.embedLink;
        pageContent.pageContent = liquidModel;
      }
      else {
        page.description.url = pageUrlObj.url;
        pageContent.pageContent = liquidModel;
      }
      page.isCustomBg = true;
    }

    pageContent.bookDocId = this.bookDataObj.bookDocId;
    this.bookDataObj.pages.splice(this.bookDataObj.pages.length - 1, 0, timestamp + "");
    page.contentDocId = pageContent._id;
    page.pageNumber = this.bookObj.pageCount;
    page.id = timestamp;
    page.type = type;
    page.title = 'Page ' + page.pageNumber;
    this.bookDataObj[timestamp + ""] = page;
    this.pageObj = page;
    await this.pouchService.updateBookObj(this.bookObj);
    await this.pouchService.updateBookDataObj(this.bookDataObj, this);
    await this.pouchService.createPageContentDoc(pageContent, this);
    await this.clickPage(obj, 'add');

  }
  clickCreatedEBEList(obj, ind) {
    this.selectedCreatedEBEListIndex = ind;
    if (obj.name == 'Delete') {
      this.deletePage();
    }
    else if (obj.name == 'Save') {
      ////In APP Feature/////
      var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Save_Page_as_Template');
      if (isFeatureAvailable == 'false') {
        this.LoginObservableService.openSubscribenowPopup();
        return;
      }
      //////////

      this.saveAsTemplate();
    }
  }
  deletePage() {
    var ref = this;
    let dialogRef = this.dialog.open(DeletePopupComponent, {
      width: '315px',
    });
    dialogRef.afterClosed().subscribe(res => {
      this.selectedCreatedEBEListIndex = undefined;
      if (res == 'yes') {
        this.deleteConfirm(this.pageObj, this.bookDataObj);
      }
    });
  }


  deleteConfirm(pageObj, bookDataObj) {
    this.bookDataObj = this.pouchService.deletePage(pageObj, bookDataObj, this.bookObj);
    this.currentPageNumber = this.bookDataObj.lastOpenedPage;
    this.setbookData();
    if (this.enrichmentTabsScope) {
      var pageIndex = this.bookDataObj["" + this.bookDataObj.lastOpenedPage].pageNumber;
      this.enrichmentTabsScope.updateTabs(this.bookDataObj.lastOpenedPage, pageIndex, this.bookDataObj["" + this.bookDataObj.lastOpenedPage]);
      this.updateEnrichLength(this.bookDataObj);
    }
  }
  saveAsTemplate() {
    var ref = this;
    let dialogRef = this.dialog.open(CreateTemplateDialogueComponent, {
      width: '315px',
    });
    dialogRef.afterClosed().subscribe(result => {
      this.selectedCreatedEBEListIndex = undefined;
      if (result != undefined) {
        // var timestamp = Math.floor(Date.now() / 1000);
        var timestamp = Constants.getGUID();
        var pageTemplate: PageTemplate = new PageTemplate();
        pageTemplate._id = Constants.USER + "." + timestamp + ".pageTemplate";
        pageTemplate.contentDocId = this.pageContentModel._id;
        pageTemplate.name = result;
        ref.pouchService.createTemplate(pageTemplate);
      }
    });
  }
  togglePagesList() {
    this.showpagesAddingCon = !this.showpagesAddingCon;
    if (this.showpagesAddingCon == true) this.elem.nativeElement.querySelectorAll('.ebePagesPopup')[0].classList.add('boxShadowForpagesDiv');
    else this.elem.nativeElement.querySelectorAll('.ebePagesPopup')[0].classList.remove('boxShadowForpagesDiv');
  }
  loadEnrichmentsTab() {
    this.loadEnrichments = true;
  }

  showEnrichments() {
    var isShow = false;
    if (this.isCreatedEBE) {
      if (this.loadEnrichments)
        isShow = true;

    }
    else {
      isShow = true;
    }

    return isShow;

  }


  clickPageFromPagesIndex(page) {

    var obj = _.filter(this.pagesArray, function (o) {

      return o.id == page.id;

    })

    this.clickPage(obj[0], '');


  }


  clickPage(pageObj, state) {
    //let layer = this.getEditorReference();   
    this.cdr.detectChanges();

    this.selectedCreatedEBEListIndex = undefined;
    if (state != 'add') {
      if (pageObj.type == 'page') this.loadEnrichments = true;
      else this.loadEnrichments = false;
    }
    this.currentPageNumber = pageObj.id;
    this.enrichmentTabs = [];
    this.rootTabActive = true;
    setTimeout(() => {
      this.getHeight();
      this.pageObj = this.bookDataObj[pageObj.id];
      if (this.enrichmentTabsScope) {
        this.enrichmentTabsScope.updateTabs(pageObj.id, pageObj.index, this.pageObj);
        this.updateEnrichLength(this.bookDataObj);
      }
      this.pouchService.getPageContent(this.bookDataObj[pageObj.id].contentDocId, this);
    }, 100);

  }

  callBackAddPage(obj) { // pages callback From pageCreation component popup
    if (!this.globalPopupPara.showPopup)
      this.selectedAddPagePopupIndex = undefined;
    if (obj && obj.type) {
      switch (obj.type) {
        case "internet":
          this.internetSearchObj.showPopup = true;
          break;
        case "youtube":
          this.youtubeSearchObj.showPopup = true;
          break;
        case "spreadSheet":
          this.googleServicesObj.showPopup = true;
          this.googleServicesObj.googleServiceType = obj.type;
          break;
        case "googleDocs":
          this.googleServicesObj.showPopup = true;
          this.googleServicesObj.googleServiceType = obj.type;
          break;
        case "presentation":
          this.googleServicesObj.showPopup = true;
          this.googleServicesObj.googleServiceType = obj.type;
          break;
        case "pageFromBook":
          this.pageFromBookObj.showPopup = true;
          // this.pageFromBookObj.bookObj = this.bookObj
          this.pageFromBookObj.bookObj = JSON.parse(JSON.stringify(this.bookObj));
          break;
        case "template":
          this.templateAsEnrichmentObj.showPopup = true;
          break;
        default:
          this.addPage(undefined, obj.type);
          break;
      }

    }

  }

  async onglobalServiceCallBack(obj) { // Services callback 
    if (obj && obj.type) {
      switch (obj.type) {
        case "internet":
        case "youtube":
          this.addPage(obj, obj.type);
          break;
        case "spreadSheet":
        case "googleDocs":
        case "presentation":
          if (obj.selectedThumbs.length > 1) {
            for (var j = 0; j < obj.selectedThumbs.length; j = j + 1) {
              await this.addPage(obj.selectedThumbs[j], obj.type);
            }
          }
          else {
           
            this.addPage(obj.selectedThumbs[0], obj.type);
          }
          break;
        case "pageFromBook":
          if (obj.selectedThumbs.length > 0) {
            this.pageFromBookCallBack(obj.selectedThumbs, obj.type);
          }
          break;
        case "template":
          if (obj.selectedThumbs.length > 1) {
            for (var k = 0; k < obj.selectedThumbs.length; k = k + 1) {
              await this.addPage(obj.selectedThumbs[k], obj.type);
            }
          }
          else {
            this.addPage(obj.selectedThumbs[0], obj.type);
          }
          break;
        default:
          break;
      }

    }

  }



  async pageFromBookCallBack(selectedThumbs, type) {
    if (selectedThumbs.length > 1) {
      for (var i = 0; i < selectedThumbs.length; i = i + 1) {
        await this.addPage(selectedThumbs[i], type);
      }
    }
    else {
      this.addPage(selectedThumbs[0], type);
    }
  }

  isshowEditOptions() {
    var isShow: boolean = false;
    if (this.rootTabActive) {
      if (this.isCreatedEBE && this.pageObj) {
        isShow = this.pageObj.type == 'blankPage' || this.pageObj.type == 'template' || this.pageObj.type == 'pageFromBook';

      }
      else
        isShow = false;

    }
    else {
      if (this.currentLoadingPage) {
        if (this.currentLoadingPage.type == "duplicateAsPage" && this.currentLoadingPage.description.url.length > 0) {
          isShow = false;
        }
        else {
          isShow = this.currentLoadingPage.type == 'blankPage' || this.currentLoadingPage.type == 'template' || this.currentLoadingPage.type == 'pageFromBook' || this.currentLoadingPage.type == 'duplicateAsPage'
            || this.currentLoadingPage.type == 'duplicateAsImage';

        }
      }
      else
        isShow = true;
    }

    return isShow;
  }
  canvaspdfHeight;
  canvaspdfWidth;
  callBackFn(pdf) {
    this.PDF_DOC = pdf;
    document.getElementsByClassName("ng2-pdf-viewer-container")[0].addEventListener("scroll", this.changeCanvasScroll);

    this.bookObj.pageCount = pdf.numPages;
    document.getElementsByClassName('showPdfloader')[0].classList.add('hidePdfloader');
    if (this.canvasPoint && this.canvasPoint.length && this.canvasLineJson.length == 0) {
      this.canvasLineJson = this.canvasPoint;
    }
    //this.bookObj.EBEComp = this;
    // do anything with "pdf"
    setTimeout(() => {
      this.canvas = document.getElementById('pdfCanvasDrawing');
      let currentCanvasDim = document.getElementsByClassName('canvasWrapper');
      this.canvaspdfHeight = currentCanvasDim[0].clientHeight + "px";
      this.canvaspdfWidth = currentCanvasDim[0].clientWidth-12 + "px";
      this.canvas.height = currentCanvasDim[0].clientHeight;
      this.canvas.width = currentCanvasDim[0].clientWidth;

      let cPdfObj = { 'pdf': pdf, 'cheight': currentCanvasDim[0].clientHeight, 'cWidth': currentCanvasDim[0].clientWidth }

      this.enrichemntspService.pdfDoc = cPdfObj;


      this.drawCanvasFromObj();
    }, 100);
  }
  changeCanvasScroll(event) {
    let CanvasOverFlow = document.getElementsByClassName("pdfCanvasDrawingCon");
    CanvasOverFlow[0].scrollTop = event.srcElement.scrollTop;
  }


  reloadEditorM() {
    this.reloadEditor = false;
    var self = this;
    setTimeout(() => {
      self.reloadEditor = true;
    }, 100);
  }
  onNotify(message) {

    this.reloadEditorM();

    if (message.state == 'pagesIndex') {
      this.currentPageNumber = message.pdfInx + 1;
      this.sliderCpos = message.pdfInx + 1;
      this.updateSlide();
      return
    }
    this.rootTabActive = message.rootTabActive;

    if (!this.rootTabActive) {
      if (message.epageContent)
        this.pageContent = message.epageContent;

    }
    else {
      if (this.isCreatedEBE) {
        this.pageObj = this.bookDataObj[this.currentPageNumber];
        this.pouchService.getPageContent(this.bookDataObj['' + this.pageObj.id].contentDocId, this);

      }

    }

    this.enrichmentTabs = message.enrichmentTabs;
    this.currentLoadingPage = message.currentLoadingPage;

    if (this.bookDataObj && this.bookDataObj[this.currentPageNumber]) {
      if (this.ctx) this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      if (this.bookDataObj[this.currentPageNumber].drawingArr && this.bookDataObj[this.currentPageNumber].drawingArr.length > 0 && this.rootTabActive) {
        this.canvasLineJson = this.bookDataObj[this.currentPageNumber].drawingArr;
        if (this.canvasLineJson.length) {
          this.canvasPoint = JSON.parse(JSON.stringify(this.canvasLineJson));
          this.pageIsDrawing = this.bookDataObj[this.currentPageNumber].drawing;
          this.drawCanvasFromObj();
        }


      }
      this.pageEnrichmentsLength = (this.bookDataObj[this.currentPageNumber].enrichment_page).length;
      this.pageNotesLength = (this.bookDataObj[this.currentPageNumber].notes).length;
    }

    this.cdr.detectChanges();
    //For Closing the drawing colour picker on change tabs
    this.isShowDrawingClr = false;
    this.isShowDrawingPicker = false;

    //To set the pdfBookViewCon height dynamically
    this.getHeight();
    
    this.pageObj = this.bookDataObj['' + this.currentPageNumber];
  }

  updateEnrichLength(data) {

    if (data[this.currentPageNumber]) {
      this.pageEnrichmentsLength = (data[this.currentPageNumber].enrichment_page).length;
      this.pageNotesLength = (data[this.currentPageNumber].notes).length;
    }
  }

  setCurrentLoadingPage() {//APP EDITOR LOADING --- Root Tab Not Active
    if (this.currentLoadingPage) {
      if (this.currentLoadingPage.type == 'duplicateAsPage' && this.currentLoadingPage.description.url.length > 0) {
        return false;

      }

      else {
        var res = this.currentLoadingPage.type == 'blankPage' || this.currentLoadingPage.type == 'template' || this.currentLoadingPage.type == 'pageFromBook' || this.currentLoadingPage.type == 'duplicateAsImage'
          || this.currentLoadingPage.type == 'duplicateAsPage';
        return res;
      }

    }
  }
  showGoogleServicesContainer() {
    if (this.currentLoadingPage.type == 'duplicateAsPage') {
      var res = this.pageObj.type == 'youtube' || this.pageObj.type == 'spreadSheet' || this.pageObj.type == 'googleDocs' || this.pageObj.type == 'presentation'
      return res;

    }
    else {
      var res = this.currentLoadingPage.type == 'youtube' || this.currentLoadingPage.type == 'spreadSheet' || this.currentLoadingPage.type == 'googleDocs' || this.currentLoadingPage.type == 'presentation'
      return res;
    }

  }
  showInternetServiceContainer() {
    if (this.currentLoadingPage.type == "duplicateAsPage") {
      var res = this.pageObj.type == 'internet';
      return res;

    }
    else {
      var res = this.currentLoadingPage.type == 'internet';
      return res;
    }

  }
  showTemplateDeleteIcons(ind) {
    if (ind == 1) {
      if (this.bookDataObj.pages.length == 3)
        return false;
      else
        return true;
    }
    else if (ind == 0) {
      if (this.rootTabActive && this.pageObj) {
        if (this.pageObj.type == 'internet' || this.pageObj.type == 'youtube' || this.pageObj.type == 'spreadSheet' || this.pageObj.type == 'googleDocs' || this.pageObj.type == 'presentation')
          return false;
        else
          return true;
      }
      else {
        return false;
      }
    }

  }



  setFullviewLoadingPage() ////APP EDITOR LOADING --- Root Tab  Active
  {

    var res = this.currentFullViewPageObj.type == 'blankPage' || this.currentFullViewPageObj.type == 'template' || this.currentFullViewPageObj.type == 'mindmap' || this.currentFullViewPageObj.type == 'pageFromBook' || this.currentFullViewPageObj.type == 'duplicateAsImage' || this.currentFullViewPageObj.type == 'duplicateAsPage';
    return res;

  }




  setRootTabLoadingPage() ////APP EDITOR LOADING --- Root Tab  Active
  {
    if (this.pageObj) {
      var res = this.pageObj.type == 'blankPage' || this.pageObj.type == 'template' || this.pageObj.type == 'mindmap' || this.pageObj.type == 'pageFromBook' || this.pageObj.type == 'duplicateAsImage' || this.pageObj.type == 'duplicateAsPage';
      return res;
    }
  }


  openNewWindow(link) {
    window.open(link);
  }





  showToolPopup(popupParams, ev, width, height, ind, pos, val): void {



    console.log(ind);
    ev.stopPropagation();
    this.isShowDrawingClr = false;
    this.isShowDrawingPicker = false;
    if (height) {
      popupParams.height = height;
    }
    if (width) {
      popupParams.width = width;
    }
    this.appendPageEnrichments = true;

    popupParams.direction = "left";
    if (pos == 'top' && ind == 2) {

      let com = this.editorService.getIframeReference();
      com.savePage();
    }
    if (pos == 'top' && ind == 1) {
      this.selectedPopupIndex = ind;
      this.NoteViewComp(popupParams, ev)
    }
    if (pos == 'top' && ind == 0) {
      ////In APP Feature/////
      var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Create_Mindmap');
      if (isFeatureAvailable == 'false') {
        this.LoginObservableService.openSubscribenowPopup();
        return;
      }
      //////////

      if (this.isCreatedEBE) {
        if (this.pageObj.enrichment_page.length > 0) this.gotoEnrichmentsPopup(popupParams, ev);
      }

      else {

        if (this.bookDataObj[this.currentPageNumber]) {
          if (this.bookDataObj[this.currentPageNumber].enrichment_page.length > 0)
            this.gotoEnrichmentsPopup(popupParams, ev);
          else return
        }
        else {
          return
        }

      }
      this.selectedPopupIndex = ind;

    }
    else if (pos == 'top' && ind == 3) {
      popupParams.arrowPos = 150;
      popupParams.height = 280;
      popupParams.width = 260;
      popupParams.isResize = false;
      popupParams.pageView = false;
      popupParams.smartview = false;
      popupParams.loadDirective = PalleteComponent;
    }
    else if (pos == "bottom" && ind == 0) {
      this.selectedBottomPopupIndex = ind;
      popupParams.hidePagesHeader = true;
      this.appendSmartViewComp(popupParams, ev);
    }
    else if (pos == "bottom" && ind == 1) {
      let aPos = 300;
      if (ev.clientY + 300 > window.innerHeight) {
        aPos = 400;
      }
      this.selectedBottomPopupIndex = ind;
      popupParams.bookObj = this.bookObj;
      popupParams.arrowPos = aPos;
      popupParams.height = 550;
      popupParams.width = 530;
      popupParams.isResize = true;
      popupParams.smartview = true;
      popupParams.pageView = false;
      popupParams.loadDirective = MiniBookComponent;
    }
    else if (pos == "bottom" && ind == 3) {

      // this.showFullViewDiv = true;
      // this.fullViewPdfPageNumber = this.currentPageNumber;
      return;
    }
    else if (pos == "left" && ind == 3 && val.state == "text") {
      popupParams.arrowPos = 250;
      popupParams.height = 300;
      popupParams.width = 260;
      popupParams.isResize = false;
      popupParams.pageView = false;
      popupParams.smartview = false;
      popupParams.loadDirective = TyphographyComponent;
      popupParams.direction = "right";
    }
    else {
      return;
    }

    if (this.appendPageEnrichments == true) {

      this.globalPopupPara = popupParams;
      this.globalPopupPara.showPopup = true;
      this.globalPopupPara.ev = ev;
    }

  }


  showCreatedEBEPopup(popupParams, ev, i) {
    ev.stopPropagation();
    this.selectedAddPagePopupIndex = i;
    if (i == 1) {
      popupParams.arrowPos = 150;
      popupParams.width = 180;
      popupParams.height = 231;
      popupParams.isResize = false;
      popupParams.loadDirective = PageCreationComponent;
      popupParams.direction = "right";
    }
    else if (i == 0) {
      // this.appendSmartViewComp(popupParams, ev);
      popupParams.hidePagesHeader = false;
      this.appendCESmartViewComp(popupParams, ev)

    }
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
  }

  getFullViewPageNumber() {
    var indd = this.bookDataObj.pages.indexOf(this.currentPageNumber.toString());
    if (indd != -1) {
      return indd;
    }
  }

  showEnrichementsFullview(state) {
    this.popupParams.showPopup = false;

    this.showEnrichmentsFullViewDiv = true;

    this.showpagesAddingCon = false;
  }

  public currentFullViewPageObj;

  showFullView() {
    this.isShowDrawingClr = false;
    this.currentFullViewPageObj = this.bookDataObj['' + this.bookDataObj.pages[0]];

    if (this.enrichmentTabsScope)
      this.enrichmentTabsScope.saveEnrichments();
    this.showFullViewDiv = true;
    if (!this.isCreatedEBE) {
      this.fullViewPageNumber = this.currentPageNumber;
      this.fullViewSliderCpos = this.currentPageNumber;
    }
    else {

      this.fullViewPageNumber = 0;
      this.pouchService.getPageContent(this.bookDataObj['' + this.bookDataObj.pages[0]].contentDocId, this);

      var self = this;
      setTimeout(function () {
        if (document.getElementsByClassName('fullViewHeaderToolBar')[0]) {
          self.showFullViewHeader = true;
          document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '100%';
        }
      }, 500);
      setTimeout(function () {
        if (document.getElementsByClassName('fullViewHeaderToolBar')[0]) {
          self.showFullViewHeader = false;
          document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '0%';
        }
      }, 2000);
    }
  }

  createdEBEListOptClick(popupParams, ev, createdEBEList, i) {
    ev.stopPropagation();
    if (createdEBEList.name == "Presentation") {
      this.selectedAddPagePopupIndex = undefined;
      this.showpagesAddingCon = false;
      this.showFullView();
      return;
    }
    else if (createdEBEList.name == "Export") {
      ////In APP Feature/////
      var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('EXPTCON');
      if (isFeatureAvailable == 'false') {
        this.LoginObservableService.openSubscribenowPopup();
        return;
      }

      this.selectedExportIconIndex = i;
      popupParams.CE = true;

      this.appendExportViewComp(popupParams, ev);

    }
  }
  // showExportBookoption(popupParams, event) {
  //   popupParams.CE = false;
  //   this.appendExportViewComp(popupParams, event);
  // }

  appendSmartViewComp(popupParams, ev) {
    let aPos = 300;
    if (ev.clientY + 300 > window.innerHeight) {
      aPos = 400;
    }
    popupParams.direction = 'right'
    popupParams.bookDataObj = this.bookDataObj;
    popupParams.pageCount = this.bookObj.pageCount;
    popupParams.arrowPos = aPos;
    popupParams.isResize = true;
    popupParams.smartview = true;
    popupParams.pageView = false;
    popupParams.width = 700;
    popupParams.height = 450;
    popupParams.loadDirective = SmartviewComponent;
  }

  appendCESmartViewComp(popupParams, ev) {
    this.popupParams.direction = "right";
    this.popupParams.bookDataObj = this.bookDataObj;
    this.popupParams.pageCount = this.bookObj.pageCount;
    this.popupParams.arrowPos = 300;
    this.popupParams.isResize = true;
    this.popupParams.smartview = true;
    this.popupParams.pageView = false;
    this.popupParams.width = 700;
    this.popupParams.height = 450;
    this.popupParams.componentState = 'CE';
    this.popupParams.hidePagesList = true;
    this.popupParams.loadDirective = SmartviewComponent

  }

  appendExportViewComp(popupParams, ev) {
    popupParams.direction = 'right'
    popupParams.bookDataObj = this.bookDataObj;
    popupParams.bookObj = this.bookObj;
    popupParams.pageCount = this.bookObj.pageCount;
    popupParams.arrowPos = 350;
    popupParams.isResize = true;
    popupParams.smartview = true;
    popupParams.pageView = false;
    popupParams.width = 700;
    popupParams.height = 450;

    popupParams.loadDirective = ExportviewComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;

  }

  NoteViewComp(popupParams, ev) {
    //this.makePageBookmark()
    if (this.bookDataObj[this.currentPageNumber] == undefined) {
      var pageObj = new Page();
      pageObj.pageNumber = this.currentPageNumber;
      pageObj.title = "Page " + this.currentPageNumber;
      this.bookDataObj[this.currentPageNumber] = pageObj;
    }
    if (this.bookDataObj[this.currentPageNumber]) {
      popupParams.direction = 'right'
      popupParams.currentPageDataObj = this.currentPageNumber;
      popupParams.bookDataObj = this.bookDataObj;
      popupParams.pageCount = this.bookObj.pageCount;
      popupParams.arrowPos = 100;
      popupParams.isResize = false;
      this.globalPopupPara = popupParams;
      this.globalPopupPara.showPopup = true;
      popupParams.width = 356;
      popupParams.height = 480;
      popupParams.loadDirective = NoteComponent;
      this.globalPopupPara.ev = ev;
      this.cdr.detectChanges();
    }
  }

  showCreatedEnrichmentsPopup(popupParams, ev) {
    ////In APP Feature/////
    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Create_Mindmap');
    if (isFeatureAvailable == 'false') {
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }
    //////////

    if (this.pageObj.enrichment_page.length == 0) return
    this.appendPageEnrichments = true;
    this.selectedCEPopupIndex = true;
    this.selectedAddPagePopupIndex = undefined;
    this.gotoEnrichmentsPopup(popupParams, ev);
    if (this.appendPageEnrichments == true) {
      this.globalPopupPara = popupParams;
      this.globalPopupPara.showPopup = true;
      this.globalPopupPara.ev = ev;
    }
  }

  gotoEnrichmentsPopup(popupParams, ev) {
    if (this.bookDataObj[this.currentPageNumber]) {
      popupParams.width = 700;
      popupParams.height = 450;
      popupParams.arrowPos = 80;
      popupParams.direction = 'right';
      popupParams.pageCount = this.bookObj.pageCount;
      popupParams.isResize = true;
      popupParams.currentPageDataObj = this.bookDataObj[this.currentPageNumber];
      popupParams.pageView = true;
      popupParams.smartview = false;
      popupParams.loadDirective = PageEnrichmentsComponent;
    }
    else {
      this.appendPageEnrichments = false;
      this.selectedPopupIndex = undefined;
      this.selectedCEPopupIndex = false;
    }
  }

  showLivePreview() {
    let layer = this.editorService.getIframeReference();
    layer.showLivePreview();
  }

  mindMapChangedPagesArray;

  updatePagesChildren(json, mmobject, state) {

    // if (state == 'delete') {

    //   this.deleteConfirm(this.pageObj, this.bookDataObj);
    //   return;
    // }

    this.mindMapChangedPagesArray = json;

    var _rev = this.bookDataObj._rev;

    var obj = new BookData();

    obj._id = this.bookDataObj._id;

    var cover1Id = this.bookDataObj.pages[0];
    var cover2Id = this.bookDataObj.pages[this.bookDataObj.pages.length - 1];
    var cover1 = this.bookDataObj[this.bookDataObj.pages[0]];
    var cover2 = this.bookDataObj[this.bookDataObj.pages[this.bookDataObj.pages.length - 1]];

    obj.lastOpenedPage = this.bookDataObj.lastOpenedPage;

    this.bookDataObj = obj;

    this.bookDataObj._rev = _rev;
    this.bookDataObj.pages = [];

    this.bookDataObj.pages.push(cover1Id.toString());

    this.bookDataObj[cover1Id] = cover1;
    for (var i = 0; i < this.mindMapChangedPagesArray.length; i++) {
      // this.mindMapChangedPagesArray[i].id = this.mindMapChangedPagesArray[i].id.toString();
      this.bookDataObj[this.mindMapChangedPagesArray[i].id + ""] = this.mindMapChangedPagesArray[i];
      this.bookDataObj.pages.push(this.mindMapChangedPagesArray[i].id.toString())
    }
    this.bookDataObj.pages.push(cover2Id.toString());
    this.bookDataObj[cover2Id] = cover2;

    this.pouchService.updateBookDataObj(this.bookDataObj, this.bookObj);

    this.updatePages();

    var pagesArrayObj = _.find(this.pagesArray, function (o) { return o.id == mmobject.id; });

    this.clickPage(pagesArrayObj, undefined);

    this.updateEnrichLength(this.bookDataObj[pagesArrayObj.id]);

  }


  gotoPageFromMindmap(object, list) {
    var timestamp = Constants.getGUID();

    // this.pageObj = list;
    var pagesArrayObj = _.find(this.pagesArray, function (o) { return o.id == list.id; });

    this.clickPage(pagesArrayObj, undefined)
  }

  showunabletodeletealert() {
    this.openSnackBar('Unable to delete last page', '');
  }


  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      panelClass: ['snack-bar-color'],
      duration: 2000,
    });
  }

  makePageBookmark() {
    ////In APP Feature/////
    this.isShowDrawingClr = false;
    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Book_mark');
    if (isFeatureAvailable == 'false') {
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }
    //////////


    this.isShowDrawingPicker = false;

    if (this.bookDataObj[this.currentPageNumber] == undefined) {

      var pageObj = new Page();
      pageObj.bookmarks = 1;
      pageObj.pageNumber = this.currentPageNumber;
      this.bookDataObj[this.currentPageNumber] = pageObj;

      this.pageIsBookmarked = 1;

    }
    else {

      if (this.bookDataObj[this.currentPageNumber].bookmarks == 0) {
        this.bookDataObj[this.currentPageNumber].bookmarks = 1;
      }

      else if (this.bookDataObj[this.currentPageNumber].bookmarks == 1) {
        this.bookDataObj[this.currentPageNumber].bookmarks = 0;
      }

      this.pageIsBookmarked = this.bookDataObj[this.currentPageNumber].bookmarks;


      //this.enrichmentTabsScope.updateTabsMindmap(this.bookDataObj);
    }


    this.pouchService.updateBookDataObj(this.bookDataObj, this);

  }


  showMoreRound(popupParams, ev, width, height): void {
    // popupParams.loadDirective = BookmoreoptionsComponent;
    // this.globalPopupPara = popupParams;
    // this.globalPopupPara.showPopup = true;
    // this.globalPopupPara.ev = ev;
    // popupParams.height = height;
    // popupParams.width = width;
    // popupParams.arrowPos = 250;
    // popupParams.direction = "top";
  }



  closePdfview() {
    var self = this;
    if (this.showFullViewDiv) {
      this.showFullViewDiv = !this.showFullViewDiv;
      this.currentFullViewPageObj = undefined;
      this.showFullViewHeader = false;
      if (this.isCreatedEBE && !this.showpagesAddingCon) {
        this.showpagesAddingCon = true;
        var indd = this.pagesArray.findIndex(obj => obj.id == this.currentPageNumber)
        if (indd != -1) {
          this.clickPage(this.pagesArray[indd], undefined);
        }
        else if (this.frontObj.id == this.currentPageNumber) {
          this.clickPage(this.frontObj, undefined);
        }
        else if (this.backObj.id == this.currentPageNumber) {
          this.clickPage(this.backObj, undefined);
        }
      }
      else {
        this.rootTabActive = true;
      }

      setTimeout(function () {
        self.getHeight();
      }, 100);

      return;
    }

    if (this.showEnrichmentsFullViewDiv) {

      this.showEnrichmentsFullViewDiv = !this.showEnrichmentsFullViewDiv;
      this.selectedPopupIndex = undefined;
      this.selectedCEPopupIndex = false;
      return;
    }

    if (this.bookDataObj) {
      this.bookDataObj.lastOpenedPage = this.currentPageNumber;

      this.enrichemntspService.update(this.currentPageNumber, this.bookDataObj);
    }

    var temp = {}
    this.Component_interactionService.selectedBookData(temp);
    this.data.appendComponentsToApp('shelf');
  }


  updateSliderData(event) {


    this.slider = document.getElementById("slider");

    this.sliderOffsetX = this.slider.getBoundingClientRect().left - document.documentElement.getBoundingClientRect().left;
    this.sliderOffsetY = this.slider.getBoundingClientRect().top - document.documentElement.getBoundingClientRect().top;

    this.sliderWidth = this.slider.offsetWidth - 1;
    var currentMouseXPos = (event.clientX + window.pageXOffset) - this.sliderOffsetX;
    var sliderValAtPos = Math.round(currentMouseXPos / this.sliderWidth * 100);
    // this...
    if (sliderValAtPos < 1) sliderValAtPos = 1;
    // ... and this are to make it easier to hover on the "0" and "100" positions

    this.sliderCpos = this.bookObj.pageCount * (sliderValAtPos / 100);
    if (this.sliderCpos > this.bookObj.pageCount) this.sliderCpos = this.bookObj.pageCount;
    this.sliderCpos = Math.round(this.sliderCpos)

    this.initializeDrawing();
    //this.updateSlide(sliderCpos);
  }

  updateSlide() {

    setTimeout(() => {
      let pdfScroll = document.getElementsByClassName("ng2-pdf-viewer-container");
      if (pdfScroll && pdfScroll[0] && pdfScroll[0].scrollTop && pdfScroll[0].scrollTop > 0) {
        pdfScroll[0].scrollTop = 0;
      }

      let pdfScrollCanvas = document.getElementsByClassName("pdfCanvasDrawingCon");
      if (pdfScrollCanvas && pdfScrollCanvas[0] && pdfScrollCanvas[0].scrollTop && pdfScrollCanvas[0].scrollTop > 0) {
        pdfScrollCanvas[0].scrollTop = 0;
      }
    }, 0);


    if (this.showFullViewDiv) {
      return;
    }
    if (this.currentPageNumber < 1) {
      this.currentPageNumber = 1;
    }
    var num = this.currentPageNumber;
    this.sliderCpos = num;
    if (!this.isCreatedEBE)
      this.currentPageNumber = num;
    else {
      if (this.bookDataObj)
        this.currentPageNumber = this.bookDataObj.pages[num];
    }


    if (this.bookDataObj && this.bookDataObj[this.currentPageNumber] != undefined) {
      this.pageEnrichmentsLength = (this.bookDataObj[this.currentPageNumber].enrichment_page).length;
      this.pageNotesLength = (this.bookDataObj[this.currentPageNumber].notes).length;
      this.pageIsBookmarked = this.bookDataObj[this.currentPageNumber].bookmarks;
      this.pageIsDrawing = this.bookDataObj[this.currentPageNumber].drawing;
    }
    else {
      this.pageEnrichmentsLength = undefined;
      this.pageNotesLength = undefined;
      this.pageIsBookmarked = 0;
      this.pageIsDrawing = 0;
    }
    if (this.ctx) this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    if (this.bookDataObj[this.currentPageNumber] && this.bookDataObj[this.currentPageNumber].drawingArr && this.bookDataObj[this.currentPageNumber].drawingArr.length > 0) {
      this.canvasLineJson = this.bookDataObj[this.currentPageNumber].drawingArr;
      //this.canvasPoint = this.canvasLineJson;
      this.canvasPoint = JSON.parse(JSON.stringify(this.canvasLineJson));
      this.drawCanvasFromObj();
    } else {
      this.canvasPoint = [];
    }



    this.enrichmentTabs = [];
    if (!this.isCreatedEBE)
      this.enrichmentTabsScope.updateTabs(num, undefined, this.bookDataObj[this.currentPageNumber]);
    else {
      this.enrichmentTabsScope.updateTabs(this.currentPageNumber, num, this.bookDataObj[this.currentPageNumber]);
      this.pouchService.getPageContent(this.bookDataObj[this.currentPageNumber].contentDocId, this);

    }

    console.log(this.panel);
    if (this.panel) {
      if (this.panel.nativeElement.querySelector(".page")) {
        var pageHeight = this.panel.nativeElement.querySelector(".page").style
          .height;
        var answer = pageHeight.substring(0, pageHeight.length - 2);
        pageHeight = Number(answer);
        this.panel.nativeElement.querySelector(
          ".ng2-pdf-viewer-container"
        ).scrollTop =
          pageHeight * (num - 1) + 10 * (num - 1);
      }
    }


  }


  comeOutFromSlider() {
    if (this.showFullViewDiv) {
      if (!this.isCreatedEBE) {
        this.fullViewSliderCpos = this.fullViewPageNumber;
      }
    }
    else {
      this.sliderCpos = this.currentPageNumber;
    }
  }

  updateBookDataObj(updatedObj) {

    //this.bookDataObj[updatedObj.pageNumber] = updatedObj;

    if (!this.isCreatedEBE) {
      this.bookDataObj[updatedObj.pageNumber] = updatedObj;
    }

    else {

      var val = this.bookDataObj.pages[(updatedObj.pageNumber)]
      this.bookDataObj[val.toString()] = updatedObj;
    }

    this.pageObj = updatedObj
    this.enrichmentTabsScope.updateTabsMindmap(this.pageObj, this.bookDataObj);

    if (this.isCreatedEBE) {
      this.rootTabActive = true;
      this.pouchService.getPageContent(this.bookDataObj[this.pageObj.id.toString()].contentDocId, this);
    }

    this.selectedPopupIndex = undefined;
    this.selectedCEPopupIndex = false;

    this.updateEnrichLength(this.pageObj);
    this.cdr.detectChanges();

  }
  showExportBookoption(popupParams, event) {
    ////In APP Feature/////
    this.isShowDrawingClr = false;
    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('EXPTCON');
    if (isFeatureAvailable == 'false') {
      this.LoginObservableService.openSubscribenowPopup();
      this.globalPopupPara.showPopup = false;
      return;
    }
    //////////
    popupParams.CE = false;
    this.appendExportViewComp(popupParams, event);


    // this.appendExportViewComp(popupParams, event);
  }
  clickCalls() {
    ////In APP Feature/////
    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Calls');
    if (isFeatureAvailable == 'false') {
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }
    //////////

  }

  gotoEnrichmentPage(data, event) {

    var pageTraverseData = data.reverse();

    //this.gotoSelectedPage(data[0].data);

    this.enrichmentTabsScope.gotoEnrichmentPage(pageTraverseData, event);

    // this.popupParams.showPopup = false;

    // this.enrichmentTabsScope.selectFirstLevelTab(data, data.index);
    this.selectedPopupIndex = undefined;

    this.selectedBottomPopupIndex = undefined;
    this.selectedCEPopupIndex = false;

  }

  gotoSelectedPage(data) {
    // this.enrichmentTabsScope.updateClickedPage(data.pageNumber - 1);
    // this.selectedPopupIndex = undefined;
    // this.selectedBottomPopupIndex = undefined;
    // this.selectedCEPopupIndex = false;

    this.rootTabActive = true;
    this.currentPageNumber = data.pageNumber;
    this.sliderCpos = data.pageNumber;
    this.updateSlide();

  }


  updatesCalledFromChild(data) {
    try {
      this.pouchService.savenote();
    }
    catch (ex) {

    }
    if (data == 'closed') {
      this.selectedPopupIndex = undefined;
      this.selectedCEPopupIndex = false;
      this.selectedBottomPopupIndex = undefined;
      // this.popupParams.showPopup = false;
      this.selectedAddPagePopupIndex = undefined;
      this.selectedExportIconIndex = undefined;
    }

    if (data == 'presentation') {


      if (this.pageObj.enrichment_page.length == 0) {

        this.openSnackBar('No enrichments to show presentation', '');
        return;
      }

      this.updateFromPageenrichState = data

      // this.showFullView(message);

      this.showEnrichementsFullview(data);

    }

    else if (data == 'download') {

      // donwloadEleService


      if (this.pageObj.enrichment_page.length == 0) {

        this.openSnackBar('No enrichments to download', '');
        return;
      }


      this.selectedPopupIndex = undefined;
      this.selectedCEPopupIndex = false;
      this.selectedBottomPopupIndex = undefined;
      // this.popupParams.showPopup = false;
      this.selectedAddPagePopupIndex = undefined;

      this.popupParams.showPopup = false;

      var ref = this;
      let dialogRef = this.dialog.open(createEleComponent, {
        width: '400px',
      });


      dialogRef.afterClosed().subscribe(res => {

        if (res != undefined) {
          // this.createNewElessonBook(res)
          document.getElementsByClassName('showDownloadloader')[0].classList.add('ShowPdfloader');

          this.dowloadservice.createNewElessonBook(res, this.pageObj)

        }

      });

    }
  }

  onPrevious() {
    if (this.isCreatedEBE) {
      if (this.fullViewPageNumber > 0) {
        this.fullViewPageNumber = this.fullViewPageNumber - 1;
        var prevPageObjId = this.bookDataObj.pages[this.fullViewPageNumber];
        this.pouchService.getPageContent(this.bookDataObj['' + prevPageObjId].contentDocId, this);
        this.currentFullViewPageObj = this.bookDataObj['' + prevPageObjId];
      }
    }
    else {
      this.fullViewPageNumber = this.fullViewPageNumber - 1;
      this.fullViewSliderCpos = this.fullViewPageNumber;
    }
  }

  onNext() {
    if (this.isCreatedEBE) {
      if (this.fullViewPageNumber < this.bookDataObj.pages.length - 1) {
        this.fullViewPageNumber = this.fullViewPageNumber + 1;
        var nextPageObjId = this.bookDataObj.pages[this.fullViewPageNumber];
        this.pouchService.getPageContent(this.bookDataObj['' + nextPageObjId].contentDocId, this);
        this.currentFullViewPageObj = this.bookDataObj['' + nextPageObjId];
      }
    }
    else {
      this.fullViewPageNumber = this.fullViewPageNumber + 1;
      this.fullViewSliderCpos = this.fullViewPageNumber;
    }
  }

  callBackFromFullviewForPageEnrich(state) {
    if (state == "closeEnrichmentsFullView") {
      this.closePdfview();
    }
    else {
      this.pouchService.getPageContent(state, this);
    }
  }

  callBackFromPdfFullview(state) {
    this.closePdfview();
  }


  createNewMiniBook(obj) {
    this.pouchService.createNewMiniBook(obj);
  }
  createExistingMiniBook(obj) {
    this.pouchService.updateMiniBookPages(obj.book, obj.thumbs);
  }



  getHeight() {

    if (this.isCreatedEBE) {
      if (this.enrichmentTabsScope && this.showEnrichments()) {
        if (this.enrichmentTabsScope.CurrentSelectedObj && this.enrichmentTabsScope.CurrentSelectedObj.children.length > 0 && this.enrichmentTabsScope.displayChildsOnSelection)
          document.getElementsByClassName('pdfBookViewCon')[0]['style'].height = 'calc(100% - 78px)';
        else {
          document.getElementsByClassName('pdfBookViewCon')[0]['style'].height = 'calc(100% - 44px)';
          // document.getElementsByClassName('pdfBookViewCon')[0]['style'].height = '100%';
        }
      }
      else
        document.getElementsByClassName('pdfBookViewCon')[0]['style'].height = '100%';
    }
    else {
      if (this.enrichmentTabsScope) {
        if (this.enrichmentTabsScope.CurrentSelectedObj && this.enrichmentTabsScope.CurrentSelectedObj.children.length > 0 && this.enrichmentTabsScope.displayChildsOnSelection)
          document.getElementsByClassName('pdfBookViewCon')[0]['style'].height = 'calc(100% - 78px)';
        else
          document.getElementsByClassName('pdfBookViewCon')[0]['style'].height = 'calc(100% - 44px)';
      }
    }
  }



  // ***********************  For Drawing the Canvas Line *********************
  showDrawing(evt) {
    if (evt.clientX + 260 > window.innerWidth) {
      this.dPosLeft = evt.currentTarget.offsetLeft - 260;
      this.dPosTop = evt.currentTarget.offsetTop - 130;
      this.tPosLeft = 251;
      this.tPosTop = 133;
    } else {
      this.dPosLeft = evt.currentTarget.offsetLeft + 50;
      this.dPosTop = evt.currentTarget.offsetTop - 130;
      this.tPosLeft = -10;
      this.tPosTop = 133;
    }
    this.isShowDrawingClr = !this.isShowDrawingClr;
  }

  canvas;
  ctx;
  flag = false;
  prevpointX = 0;
  currentPointX = 0;
  prevpointY = 0;
  currentPointY = 0;
  dot_flag = false;
  canvasStrokeColor = "black";
  canvasLineWidth = 1;
  dPosLeft;
  dPosTop;
  tPosLeft;
  tPosTop;
  canvasWidth;
  canvasHeight;
  canvasLineJson = [];
  isShowDrawingClr = false;
  canvasLineOpacity = 1;
  initializeDrawing() {
    // this.canvas = document.getElementById('page' + this.currentPageNumber);
    this.canvas = document.getElementById('pdfCanvasDrawing');
    this.ctx = this.canvas.getContext("2d");
    this.canvasWidth = this.canvas.width;
    this.canvasHeight = this.canvas.height;
    //this.canvasPoint = [];
  }
  // changeCanvasColor(color) {
  //   this.canvasStrokeColor = color;
  // }

  changeDrawingColour(props) {
    this.canvasStrokeColor = props.color;
    this.canvasLineWidth = props.thickness;
    this.canvasLineOpacity = props.opacity;
  }

  @HostListener('mouseup', ['$event'])
  onMouseup(event: MouseEvent) {
    this.findPosition('up', event);
  }
  @HostListener('mousemove', ['$event'])
  onMousemove(event: MouseEvent) {
    this.findPosition('move', event);
  }
  @HostListener('mousedown', ['$event'])
  onMousedown(event) {
    this.findPosition('down', event);
  }
  @HostListener('mouseout', ['$event'])
  onmouseout(event) {
    this.findPosition('out', event);
  }
  @HostListener('scroll') dosomething() {
    console.log("dfasdasd");
  }
  myMethod(evt) {
    let pdfOverFlow = document.getElementsByClassName("ng2-pdf-viewer-container");
    pdfOverFlow[0].scrollTop = evt.srcElement.scrollTop;
  }

  findPosition(res, e) {

    if (this.isShowDrawingPicker) {
      let pdfScrollLeft;
      let pdfScrollTop;
      let pdfView: any = document.getElementsByClassName("pdfPageView");
      let elmnt: any = document.getElementsByClassName("ng2-pdf-viewer-container");
      if (elmnt.length > 0) {
        pdfScrollLeft = elmnt[0].scrollLeft;
        pdfScrollTop = elmnt[0].scrollTop;
      }
      if (res == 'down') {
        this.prevpointX = this.currentPointX;
        this.prevpointY = this.currentPointY;

        this.currentPointX = e.offsetX;
        this.currentPointY = e.offsetY;

        this.flag = true;
        this.dot_flag = true;
        if (this.dot_flag) {
          //  this.ctx.beginPath();
          // this.ctx.fillStyle = this.canvasStrokeColor;
          // this.ctx.fillRect(this.currentPointX, this.currentPointY, 2, 2);
          //  this.ctx.closePath();
          let canvaObj: any = {};
          canvaObj.X1 = this.prevpointX;
          canvaObj.Y1 = this.prevpointY;
          this.canvasPoint.push(canvaObj);
          this.dot_flag = false;
        }
      }
      if (res == 'up' || res == "out") {
        this.flag = false;
      }
      if (res == 'move') {
        if (this.flag) {
          this.prevpointX = this.currentPointX;
          this.prevpointY = this.currentPointY;
          this.currentPointX = e.offsetX;
          this.currentPointY = e.offsetY;
          this.draw();
        }
      }
    }
  }
  saveDrawing() {
    if (!this.bookDataObj[this.currentPageNumber]) {
      var page: Page = new Page();
      page.pageNumber = this.currentPageNumber;
      this.bookDataObj[this.currentPageNumber] = page;
    }
    if (this.canvasPoint.length > 0) {
      this.bookDataObj[this.currentPageNumber].drawing = 1;
      this.pageIsBookmarked = 1;
    }
    else {
      this.bookDataObj[this.currentPageNumber].drawing = 0;
      this.pageIsBookmarked = 0;
    }



    this.bookDataObj[this.currentPageNumber].drawingArr = this.canvasPoint;
    this.pouchService.updateBookDataObj(this.bookDataObj, this);
  }
  draw() {
    this.ctx.beginPath();
    this.ctx.moveTo(this.prevpointX, this.prevpointY);
    this.ctx.lineTo(this.currentPointX, this.currentPointY);
    this.ctx.strokeStyle = this.canvasStrokeColor;
    this.ctx.lineWidth = this.canvasLineWidth;
    this.ctx.globalAlpha = this.canvasLineOpacity;
    this.ctx.stroke();
    this.ctx.closePath();
    let canvaObj: any = {};
    canvaObj.X1 = this.prevpointX;
    canvaObj.Y1 = this.prevpointY;
    canvaObj.X2 = this.currentPointX;
    canvaObj.Y2 = this.currentPointY;
    canvaObj.color = this.canvasStrokeColor;
    canvaObj.thikness = this.canvasLineWidth;
    canvaObj.opacity = this.canvasLineOpacity;
    this.canvasPoint.push(canvaObj);
    this.saveDrawing();
    // console.log(JSON.stringify(this.canvasPoint));
    // console.log("================================");
  }
  num
  drawCanvasFromObj() {
    this.canvas = document.getElementById('pdfCanvasDrawing');
    if (this.canvas) {
      this.ctx = this.canvas.getContext("2d");
      this.canvasWidth = this.canvas.width;
      this.canvasHeight = this.canvas.height;
      if (this.canvasLineJson && this.canvasLineJson.length) {
        for (this.num = 0; this.num < this.canvasLineJson.length; this.num++) {
          if (this.canvasLineJson[this.num].X2 && this.canvasLineJson[this.num].Y2) {
            this.drawLineOnColourChange(this.num);
          }
        }
      }
    }
  }

  drawLineOnColourChange(i1) {
    this.ctx.beginPath();

    this.ctx.moveTo(this.canvasLineJson[this.num].X1, this.canvasLineJson[this.num].Y1);
    for (this.num = i1; this.num < this.canvasLineJson.length; this.num++) {
      this.ctx.lineTo(this.canvasLineJson[this.num].X2, this.canvasLineJson[this.num].Y2);

      if (this.canvasLineJson[this.num].X2 == undefined && this.canvasLineJson[this.num].Y2 == undefined) {
        this.ctx.strokeStyle = this.canvasLineJson[this.num - 1].color;
        this.ctx.lineWidth = this.canvasLineJson[this.num - 1].thikness;
        this.ctx.globalAlpha = this.canvasLineJson[this.num - 1].opacity;
        this.ctx.stroke();
        this.ctx.closePath();
        return;
      }
    }
    this.ctx.strokeStyle = this.canvasLineJson[this.num - 1].color;
    this.ctx.lineWidth = this.canvasLineJson[this.num - 1].thikness;
    this.ctx.globalAlpha = this.canvasLineJson[this.num - 1].opacity;
    this.ctx.stroke();
    this.ctx.closePath();
  }

  eraseDrawing() {
    this.canvasPoint = this.canvasLineJson = [];
    this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
    this.isShowDrawingClr = false;
    this.saveDrawing();
    // this.ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
  }
  showDrawingPicker() {
    ////In APP Feature/////
    if (!this.isShowDrawingPicker) {
      let pdfDcon = document.getElementsByClassName('pdfCanvasDrawingCon');
      this.zoomPlusMinus = 1;
      pdfDcon[0]['style'].zIndex = '';
    }
    var isFeatureAvailable = this.LoginObservableService.isThisFeatureIsAvailable('Drawing');
    if (isFeatureAvailable == 'false') {
      this.LoginObservableService.openSubscribenowPopup();
      return;
    }
    //////////


    this.isShowDrawingPicker = !this.isShowDrawingPicker;
    if (!this.isShowDrawingPicker) {
      this.isShowDrawingClr = false;
    }
    // this.initializeDrawing();
  }
  // ***********************  End Of Drawing the Canvas Line *********************

  // book info popup

  showBookDetails(popupParams: any, ev, width, height, book, ShelfName): void {

    popupParams.loadDirective = BookInfoComponent;
    this.globalPopupPara = popupParams;
    this.globalPopupPara.showPopup = true;
    this.globalPopupPara.ev = ev;
    popupParams.height = height;
    popupParams.width = width;
    popupParams.arrowPos = 130;
    popupParams.direction = "top";
    popupParams.isResize = false;
    popupParams.bookDetals = true;
  }

  onFullViewHeaderMouseEnter() {
    this.showFullViewHeader = true;
    document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '100%';
  }

  onFullViewHeaderMouseLeave() {
    this.showFullViewHeader = false;
    document.getElementsByClassName('fullViewHeaderToolBar')[0]['style'].height = '0%';
  }

  pdfZoomInOut(zoom) {
    let pdfDcon = document.getElementsByClassName('pdfCanvasDrawingCon');
    if (pdfDcon.length)
      pdfDcon[0]['style'].zIndex = -1;
    if (zoom == 'plus')
      this.zoomPlusMinus = this.zoomPlusMinus + 0.1;
    if (zoom == 'minus') {
      if (this.zoomPlusMinus < 0.11) return;
      this.zoomPlusMinus = this.zoomPlusMinus - 0.1;
    }
    if (this.zoomPlusMinus == 1) {
      pdfDcon[0]['style'].zIndex = '';
    }
  }
  // canvasImgSrc;
  // generatePdfThumb() {
  //   debugger;
  //   var CANVAS: any = document.createElement('canvas');
  //   CANVAS.width = 300;
  //   CANVAS.height = 300;
  //   CANVAS.style.position = "absolute";
  //   var CANVAS_CTX = CANVAS.getContext('2d');
  //   let that = this;
  //   let page_no = this.currentPageNumber;



}



// WEBPACK FOOTER //
// ./src/app/EBE/EBE.component.ts